import { DailyLoadFileType } from './DailyLoadFileType';

export const DailyLoadFileTypes:Map<string, string> = new Map([
  [DailyLoadFileType.PRE_TRANSFORM, 'Pre-Transformation'],
  [DailyLoadFileType.FIDIL, 'FIDIL'],
  [DailyLoadFileType.UFF_TRANSFORMATION, 'UFF Transformation'],
  [DailyLoadFileType.CREDIT_CARD, 'Credit Card'],
]);

export default DailyLoadFileTypes;
